import React, { useRef, useState } from "react";
import usericon from "../assets/images/profile-icon.webp";
import product11 from "../assets/images/product-11.png";
import iconbagsvg from "../assets/images/icon-bag.svg";

import { Link } from "react-router-dom";

function NavTest(props) {
  const buttonRef = useRef(null);

  const [isToggled, setToggled] = useState(false);
  const [linkToggled, setLinkToggled] = useState(false);

  const handleClick = (e) => {
    if (buttonRef.current) {
      buttonRef.current.classList.toggle("active");
      setToggled(!isToggled);
      setLinkToggled(!linkToggled);
    }
  };

  return (
    <>
      <nav className="dx-navbar dx-navbar-top dx-navbar-collapse dx-navbar-sticky dx-navbar-expand-lg dx-navbar-dropdown-triangle dx-navbar-autohide">
        <div className="container">
          <Link to="/" className="dx-nav-logo"></Link>
          <button
            className="dx-navbar-burger"
            ref={buttonRef}
            onClick={handleClick}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div className="dx-navbar-content">
            <ul className="dx-nav">
              <li className="dx-nav-item dx-nav-item-drop">
                <Link className="dx-nav-link" to="/store">
                  {" "}
                  Store{" "}
                </Link>
                <ul className="dx-navbar-dropdown">
                  <li>
                    <Link className="dx-nav-link" to="/store">
                      {" "}
                      Store{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="dx-nav-link" to="/product">
                      {" "}
                      Product{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="dx-nav-link" to="/checkout">
                      {" "}
                      Checkout{" "}
                    </Link>
                  </li>
                  <div className="dx-navbar-dropdown-triangle"></div>
                </ul>
              </li>
              <li className="dx-nav-item dx-nav-item-drop">
                <Link className="dx-nav-link" to="/blog">
                  {" "}
                  Blog{" "}
                </Link>
                <ul className="dx-navbar-dropdown">
                  <li>
                    <Link className="dx-nav-link" to="/blog">
                      {" "}
                      Blog{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="dx-nav-link" to="/single-post">
                      {" "}
                      Single Post{" "}
                    </Link>
                  </li>
                  <div className="dx-navbar-dropdown-triangle"></div>
                </ul>
              </li>
              <li className="dx-nav-item dx-nav-item-drop">
                <Link className="dx-nav-link" to="/help-center">
                  {" "}
                  Help Center{" "}
                </Link>
                <ul className="dx-navbar-dropdown">
                  <li>
                    <Link className="dx-nav-link" to="/help-center">
                      {" "}
                      Help Center{" "}
                    </Link>
                  </li>
                  <li className="dx-nav-item dx-nav-item-drop">
                    <Link className="dx-nav-link" to="/documentations">
                      {" "}
                      Documentations{" "}
                    </Link>
                    <ul className="dx-navbar-dropdown">
                      <li>
                        <Link className="dx-nav-link" to="/documentations">
                          {" "}
                          Documentations{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dx-nav-link"
                          to="/single-documentation"
                        >
                          {" "}
                          Single documentation{" "}
                        </Link>
                      </li>
                      <div className="dx-navbar-dropdown-triangle"></div>
                    </ul>
                  </li>
                  <li className="dx-nav-item dx-nav-item-drop">
                    <Link className="dx-nav-link" to="/articles">
                      {" "}
                      Knowledge Base{" "}
                    </Link>
                    <ul className="dx-navbar-dropdown">
                      <li>
                        <Link className="dx-nav-link" to="/articles">
                          {" "}
                          Knowledge Base{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dx-nav-link"
                          to="/single-article-category"
                        >
                          {" "}
                          Single Article Category{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/single-article">
                          {" "}
                          Single Article{" "}
                        </Link>
                      </li>
                      <div className="dx-navbar-dropdown-triangle"></div>
                    </ul>
                  </li>
                  <li className="dx-nav-item dx-nav-item-drop">
                    <Link className="dx-nav-link" to="/forums">
                      {" "}
                      Forums{" "}
                    </Link>
                    <ul className="dx-navbar-dropdown">
                      <li>
                        <Link className="dx-nav-link" to="/forums">
                          {" "}
                          Forums{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/topics">
                          {" "}
                          Topics{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/single-topic">
                          {" "}
                          Single Topic{" "}
                        </Link>
                      </li>
                      <div className="dx-navbar-dropdown-triangle"></div>
                    </ul>
                  </li>
                  <li className="dx-nav-item dx-nav-item-drop">
                    <Link className="dx-nav-link" to="/ticket">
                      {" "}
                      Ticket System{" "}
                    </Link>
                    <ul className="dx-navbar-dropdown">
                      <li>
                        <Link className="dx-nav-link" to="/ticket">
                          {" "}
                          Ticket System{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/ticket-submit">
                          {" "}
                          Submit Ticket{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/ticket-submit-2">
                          {" "}
                          Submit Ticket 2{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/single-ticket">
                          {" "}
                          Single Ticket{" "}
                        </Link>
                      </li>
                      <div className="dx-navbar-dropdown-triangle"></div>
                    </ul>
                  </li>
                  <div className="dx-navbar-dropdown-triangle"></div>
                </ul>
              </li>
              <li className="dx-nav-item dx-nav-item-drop active">
                <Link className="dx-nav-link" to="/account">
                  {" "}
                  Account{" "}
                </Link>
                <ul className="dx-navbar-dropdown">
                  <li>
                    <Link className="dx-nav-link" to="/account">
                      {" "}
                      Account{" "}
                    </Link>
                  </li>
                  <li className="dx-nav-item active">
                    <Link className="dx-nav-link" to="/account-licenses">
                      {" "}
                      Licenses{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="dx-nav-link" to="/account-settings">
                      {" "}
                      Settings{" "}
                    </Link>
                  </li>
                  <div className="dx-navbar-dropdown-triangle"></div>
                </ul>
              </li>
            </ul>
            <ul className="dx-nav dx-nav-align-right">
              <li className="dx-nav-item dx-nav-item-drop">
                <Link className="dx-nav-icon" to="/#" role="button">
                  <span className="dx-nav-badge">2</span>
                  <img
                    className="icon"
                    style={{ width: "22px" }}
                    src={iconbagsvg}
                    alt=""
                  />
                </Link>
                <div className="dx-navbar-dropdown dx-navbar-dropdown-left dx-dropdown-checkout">
                  <div className="dx-navbar-dropdown-triangle"></div>
                  <table className="dx-table dx-table-checkout">
                    <tbody>
                      <tr>
                        <th scope="row" className="dx-table-checkout-img">
                          <Link to="/product">
                            <img src={product11} alt="" />
                          </Link>
                        </th>
                        <td className="dx-table-checkout-title">
                          <Link to="/product">
                            Sensific – Saying Beast Lesser for in Fruitful
                          </Link>
                        </td>
                        <td className="dx-table-checkout-price">
                          <div className="dx-table-checkout-price">$59</div>
                        </td>
                        <td className="dx-table-checkout-delete">
                          <Link to="/#">
                            <span className="icon pe-7s-close"></span>
                          </Link>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" className="dx-table-checkout-img">
                          <Link to="/product">
                            <img src={product11} alt="" />
                          </Link>
                        </th>
                        <td className="dx-table-checkout-title">
                          <Link to="/product">
                            Minist – Subdue Above for Signs Dry is Have Great
                          </Link>
                        </td>
                        <td className="dx-table-checkout-price">
                          <div className="dx-table-checkout-price">$39</div>
                        </td>
                        <td className="dx-table-checkout-delete">
                          <Link to="/#">
                            <span className="icon pe-7s-close"></span>
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="d-flex justify-content-between dx-box-content pt-0 pb-0 mt-15 mnb-6">
                    <span>Total Payment:</span>
                    <span>
                      <strong>$98</strong>
                    </span>
                  </div>
                  <div className="dx-box-content">
                    <Link
                      to="/checkout"
                      className="dx-btn dx-btn-md dx-btn-block"
                    >
                      Checkout
                    </Link>
                  </div>
                </div>
              </li>
              <li className="dx-nav-item dx-nav-item-drop">
                <Link className="dx-nav-signin" to="/account" role="button">
                  <span className="dx-nav-signin-img">
                    <img src={usericon} alt="" />
                  </span>
                  <span className="dx-nav-signin-name">John Leonard</span>
                </Link>
                <ul className="dx-navbar-dropdown dx-dropdown-signin">
                  <div className="dx-navbar-dropdown-triangle"></div>
                  <li className="dx-nav-item">
                    <Link to="/account" className="dx-nav-link">
                      <span className="icon pe-7s-user"></span> Account
                    </Link>
                  </li>
                  <li className="dx-nav-item">
                    <Link to="/login" className="dx-nav-link">
                      <span className="icon pe-7s-user"></span> Login/Register
                    </Link>
                  </li>
                  <li className="dx-nav-item">
                    <Link to="/account-licenses" className="dx-nav-link">
                      <span className="icon pe-7s-download"></span> Items &
                      Licenses
                    </Link>
                  </li>
                  <li className="dx-nav-item">
                    <Link to="/account-settings" className="dx-nav-link">
                      <span className="icon pe-7s-config"></span> Settings
                    </Link>
                  </li>
                  <li className="dx-nav-item">
                    <Link to="/#" className="dx-nav-link">
                      <span className="icon pe-7s-back"></span> Logout
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div
        className={
          isToggled && linkToggled
            ? "dx-navbar dx-navbar-fullscreen dx-navbar-fullscreen-open"
            : "dx-navbar dx-navbar-fullscreen dx-navbar-fullscreen-closed"
        }
      >
        <div className="container">
          <button
            className="dx-navbar-burger"
            ref={buttonRef}
            onClick={handleClick}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div className="dx-navbar-content">
            <ul className="dx-nav dx-nav-align-left">
              <li className="dx-nav-item dx-nav-item-drop">
                <Link className="dx-nav-link" to="/store">
                  {" "}
                  Store{" "}
                </Link>
                <ul className="dx-navbar-dropdown">
                  <li>
                    <Link className="dx-nav-link" to="/store">
                      {" "}
                      Store{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="dx-nav-link" to="/product">
                      {" "}
                      Product{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="dx-nav-link" to="/checkout">
                      {" "}
                      Checkout{" "}
                    </Link>
                  </li>
                  <div className="dx-navbar-dropdown-triangle"></div>
                </ul>
              </li>
              <li className="dx-nav-item dx-nav-item-drop">
                <Link className="dx-nav-link" to="/blog">
                  {" "}
                  Blog{" "}
                </Link>
                <ul className="dx-navbar-dropdown">
                  <li>
                    <Link className="dx-nav-link" to="/blog">
                      {" "}
                      Blog{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="dx-nav-link" to="/single-post">
                      {" "}
                      Single Post{" "}
                    </Link>
                  </li>
                  <div className="dx-navbar-dropdown-triangle"></div>
                </ul>
              </li>
              <li className="dx-nav-item dx-nav-item-drop">
                <Link className="dx-nav-link" to="/help-center">
                  {" "}
                  Help Center{" "}
                </Link>
                <ul className="dx-navbar-dropdown">
                  <li>
                    <Link className="dx-nav-link" to="/help-center">
                      {" "}
                      Help Center{" "}
                    </Link>
                  </li>
                  <li className="dx-nav-item dx-nav-item-drop">
                    <Link className="dx-nav-link" to="/documentations">
                      {" "}
                      Documentations{" "}
                    </Link>
                    <ul className="dx-navbar-dropdown">
                      <li>
                        <Link className="dx-nav-link" to="/documentations">
                          {" "}
                          Documentations{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dx-nav-link"
                          to="/single-documentation"
                        >
                          {" "}
                          Single documentation{" "}
                        </Link>
                      </li>
                      <div className="dx-navbar-dropdown-triangle"></div>
                    </ul>
                  </li>
                  <li className="dx-nav-item dx-nav-item-drop">
                    <Link className="dx-nav-link" to="/articles">
                      {" "}
                      Knowledge Base{" "}
                    </Link>
                    <ul className="dx-navbar-dropdown">
                      <li>
                        <Link className="dx-nav-link" to="/articles">
                          {" "}
                          Knowledge Base{" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dx-nav-link"
                          to="/single-article-category"
                        >
                          {" "}
                          Single Article Category{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/single-article">
                          {" "}
                          Single Article{" "}
                        </Link>
                      </li>
                      <div className="dx-navbar-dropdown-triangle"></div>
                    </ul>
                  </li>
                  <li className="dx-nav-item dx-nav-item-drop">
                    <Link className="dx-nav-link" to="/forums">
                      {" "}
                      Forums{" "}
                    </Link>
                    <ul className="dx-navbar-dropdown">
                      <li>
                        <Link className="dx-nav-link" to="/forums">
                          {" "}
                          Forums{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/topics">
                          {" "}
                          Topics{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/single-topic">
                          {" "}
                          Single Topic{" "}
                        </Link>
                      </li>
                      <div className="dx-navbar-dropdown-triangle"></div>
                    </ul>
                  </li>
                  <li className="dx-nav-item dx-nav-item-drop">
                    <Link className="dx-nav-link" to="/ticket">
                      {" "}
                      Ticket System{" "}
                    </Link>
                    <ul className="dx-navbar-dropdown">
                      <li>
                        <Link className="dx-nav-link" to="/ticket">
                          {" "}
                          Ticket System{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/ticket-submit">
                          {" "}
                          Submit Ticket{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/ticket-submit-2">
                          {" "}
                          Submit Ticket 2{" "}
                        </Link>
                      </li>
                      <li>
                        <Link className="dx-nav-link" to="/single-ticket">
                          {" "}
                          Single Ticket{" "}
                        </Link>
                      </li>
                      <div className="dx-navbar-dropdown-triangle"></div>
                    </ul>
                  </li>
                  <div className="dx-navbar-dropdown-triangle"></div>
                </ul>
              </li>
              <li className="dx-nav-item dx-nav-item-drop active">
                <Link className="dx-nav-link" to="/account">
                  {" "}
                  Account{" "}
                </Link>
                <ul className="dx-navbar-dropdown">
                  <li>
                    <Link className="dx-nav-link" to="/account">
                      {" "}
                      Account{" "}
                    </Link>
                  </li>
                  <li className="dx-nav-item active">
                    <Link className="dx-nav-link" to="/account-licenses">
                      {" "}
                      Licenses{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className="dx-nav-link" to="/account-settings">
                      {" "}
                      Settings{" "}
                    </Link>
                  </li>
                  <div className="dx-navbar-dropdown-triangle"></div>
                </ul>
              </li>
            </ul>
            <ul className="dx-nav dx-nav-align-right justify-content-between">
              <li>
                <span>
                  <Link className="dx-nav-signin" to="/account">
                    <span className="dx-nav-signin-img">
                      <img src={product11} alt="" />
                    </span>
                    <span className="dx-nav-signin-name">John Leonard</span>
                  </Link>
                </span>
              </li>
              <li>
                <Link className="dx-nav-icon mnt-8" to="/checkout">
                  <span className="dx-nav-badge">2</span>
                  <span className="icon dx-icon-bag"></span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default NavTest;
